import AddStudent from "./AddStudent";
import { AddStudentProps } from "./AddStudent";
export default AddStudent;
export type { AddStudentProps }